export default __webpack_public_path__ + "static/media/keyvisual-mainfranken-wuerzburg.b93ef3d3.jpg";